import { PlantDto } from 'src/store/plants/plant';
import { ArrayUtils } from 'src/utils/array';
import { PlantAction, PlantTypes } from './plants.actions';

export type PlantsState = Readonly<{
  plants: PlantDto[];
  errors: any;
}>;

const initialState: PlantsState = {
  plants: [],
  errors: null
};

const plantsReducer = (
  state: PlantsState = initialState,
  action: PlantAction
) => {
  switch (action.type) {
    case PlantTypes.FetchAll:
      return { ...state, plants: action.plants };
    case PlantTypes.Add:
      return { ...state, plants: [...state.plants, action.plant] };
    case PlantTypes.Update:
      return {
        ...state,
        plants: ArrayUtils.updateListById(state.plants, action.plant)
      };
    case PlantTypes.Delete:
      return {
        ...state,
        plant: null,
        plants: ArrayUtils.deleteFromListById(state.plants, action.plant)
      };
    case PlantTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default plantsReducer;
